import React, {useEffect} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {
    createUser, editUserDataFields,
    getAllowedUserRoles,
    getUserListWithPagination, setIsUserAdding,
} from '../../store/usersReducer'
import UserModal from '../common/UsersTable/UserModal'


const UsersModal = (props) => {
    const dispatch = useDispatch()
    const userRoles = useSelector(state => state.usersReducer.allowedUserRoles)
    const page = useSelector(state => state.usersReducer.currentPage)


    useEffect(() => {
        dispatch(getAllowedUserRoles())
    }, [dispatch])

    const closeModal = () => {
        props.setModalData({isOpen: false})
    }

    const editUser = (userData, userId, custId) => {
        dispatch(editUserDataFields(userData, userId))
            .then((resp) => !!resp && closeModal())
            .then(() => {
                if (props.searchedValue) {
                    dispatch(getUserListWithPagination({
                        pagination_request: {
                            page: page,
                            size: 10,
                            sort: []
                        },
                        filter_request: {
                            search_value: props.searchedValue
                        }
                    }))
                } else {
                    dispatch(getUserListWithPagination({
                        pagination_request: {
                            page: page,
                            size: 10,
                            sort: []
                        }
                    }))
                }

            })
    }

    const addUser = (userData) => {
        dispatch(createUser(userData))
            .then((resp) => !!resp && closeModal())
            .then(() => {
                dispatch(setIsUserAdding(false))
                if(props.searchedValue){
                    dispatch(getUserListWithPagination({
                        pagination_request: {
                            page: page,
                            size: 10,
                            sort: []
                        },
                        filter_request: {
                            search_value: props.searchedValue
                        }
                    }))
                }
                else{
                    dispatch(getUserListWithPagination({
                        pagination_request: {
                            page: page,
                            size: 10,
                            sort: []
                        }
                    }))
                }

            })
    }

    return (
        <UserModal
            addUser={addUser}
            editUser={editUser}
            modalData={props.modalData}
            setModalData={props.setModalData}
            setUsersModalData={props.setModalData}
            roleOptions={userRoles}
            isUsersTable={props.isUsersTable}
        />
    )
}



export default UsersModal
